$(document).ready(function(){
    handleAccordionBlock();
    initTooltips();
    handleDisclaimerToggles();
    handleSimulatorBlock();
});

function handleAccordionBlock() {
    if($('.accordion-block').length && $('.accordion-w-image').length){
        document.querySelectorAll('.accordion-block').forEach(block => {
            const mediaItems = block.querySelectorAll('.accordion-media-item');
            if (!mediaItems.length) return;

            block.querySelectorAll('.accordion-collapse-img').forEach(collapse => {
                collapse.addEventListener('show.bs.collapse', function () {
                    const mediaIndex = this.getAttribute('data-accordion-media-index');
                    mediaItems.forEach(mediaItem => {
                        mediaItem.classList.toggle(
                            'active',
                            mediaItem.getAttribute('data-accordion-media-index') === mediaIndex
                        );
                    });
                });
            });
        });
    }
}

function initTooltips(scope = document) {
    const tooltipTriggerList = [].slice.call(
        scope.querySelectorAll('[data-bs-toggle="tooltip"]')
    );

    tooltipTriggerList.forEach(function (el) {

        // prevent duplicates
        let instance = bootstrap.Tooltip.getInstance(el);
        if (!instance) {
            instance = new bootstrap.Tooltip(el);
        }

        // ensure only one tooltip open at a time
        el.addEventListener('show.bs.tooltip', function () {

            document
                .querySelectorAll('[data-bs-toggle="tooltip"]')
                .forEach(function (otherEl) {

                    if (otherEl !== el) {
                        const otherInstance =
                            bootstrap.Tooltip.getInstance(otherEl);

                        if (otherInstance) {
                            otherInstance.hide();
                        }
                    }
                });
        });
    });
}

//Hide tooltips when clicking outside of them
document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-bs-toggle="tooltip"]')) {
        document
            .querySelectorAll('[data-bs-toggle="tooltip"]')
            .forEach(el => {
                const instance = bootstrap.Tooltip.getInstance(el);
                if (instance) instance.hide();
            });
    }
});

function handleDisclaimerToggles() {
    const disclaimers = document.querySelectorAll(".disclaimer");
    if (!disclaimers.length) return;

    function appendToggleToText(text, toggle) {
        const lastParagraph = text.querySelector("p:last-child");

        if (lastParagraph) {
            lastParagraph.append(toggle);
            return;
        }

        text.append(toggle);
    }

    function setDisclaimerState(disclaimer, isExpanded) {
        const text = disclaimer.querySelector(".disclaimer-text");
        const toggle = disclaimer.querySelector(".disclaimer-toggle");
        const previewTemplate = disclaimer.querySelector(".disclaimer-preview-template");
        const fullTemplate = disclaimer.querySelector(".disclaimer-full-template");
        if (!text || !toggle || !previewTemplate || !fullTemplate) return;

        text.classList.toggle("is-expanded", isExpanded);
        text.innerHTML = isExpanded ? fullTemplate.innerHTML : previewTemplate.innerHTML;
        toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
        toggle.textContent = ` ${isExpanded ? toggle.dataset.lessText : toggle.dataset.moreText}`;
        appendToggleToText(text, toggle);
    }

    disclaimers.forEach((disclaimer) => {
        const text = disclaimer.querySelector(".disclaimer-text");
        const toggle = disclaimer.querySelector(".disclaimer-toggle");
        if (!text || !toggle) return;

        setDisclaimerState(disclaimer, false);

        toggle.addEventListener("click", function () {
            const isExpanded = !text.classList.contains("is-expanded");
            setDisclaimerState(disclaimer, isExpanded);
        });
    });
}

function handleSimulatorBlock() {
    if($('.vertical-tab-block').length){
        const ajaxUrl = window.ajaxConfig?.ajaxUrl;
        const nonce = window.ajaxConfig?.nonce;
        const simulatorDetailsModalEl = document.getElementById("simulator-details-modal");
        const simulatorIframeBaseUrl = simulatorDetailsModalEl?.dataset.iframeBaseUrl?.trim();
        const simulatorDetailsFrame = simulatorDetailsModalEl?.querySelector(".simulator-details-iframe");
        const simulatorDetailsModal = simulatorDetailsModalEl ? new bootstrap.Modal(simulatorDetailsModalEl) : null;

        if (simulatorDetailsModalEl && simulatorDetailsFrame) {
            simulatorDetailsModalEl.addEventListener("hidden.bs.modal", function () {
                simulatorDetailsFrame.src = "about:blank";
            });
        }

        function openSimulatorDetailsModal(onboardingUrl) {
            if (!onboardingUrl) return;
            if (!simulatorDetailsModal || !simulatorDetailsFrame) return;

            simulatorDetailsFrame.src = onboardingUrl;
            simulatorDetailsModal.show();
        }

        function syncSimulatorAmounts(sourceSimulatorEl) {
            if (!sourceSimulatorEl) return;

            const sourceInput = sourceSimulatorEl.querySelector(".simulator-amount");
            const sourceValue = sourceInput?.value ?? "";

            document.querySelectorAll(".simulator-instance").forEach((simulatorEl) => {
                const amountInput = simulatorEl.querySelector(".simulator-amount");
                if (!amountInput) return;

                amountInput.value = sourceValue;
                simulatorEl.dataset.simulated = "false";
                updateSimulatorLink(simulatorEl);
            });
        }

        async function runSimulation(simulatorEl) {
            if (!simulatorEl) return;

            const amountInput = simulatorEl.querySelector(".simulator-amount");
            const amount = amountInput?.value?.trim();
            const portfolioType = simulatorEl.dataset.portfolioType?.trim();

            if (!amount || !portfolioType) {
                console.error("Missing amount or portfolio type");
                return;
            }

            if (!ajaxUrl || !nonce) {
                console.error("Missing AJAX config");
                return;
            }

            const rawAmount = amountInput?.value?.replace(/,/g, "").trim();
            const min = Number(amountInput?.dataset.min || 5000);

            if (!rawAmount || Number.isNaN(Number(rawAmount))) {
                console.error("Invalid amount");
                return;
            }

            if (Number(rawAmount) < min) {
                amountInput.value = min.toLocaleString("en-US", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                });
                amountInput.focus();
                console.error(`Minimum amount is ${min}`);
                return;
            }

            try {
                setSimulatorLoading(simulatorEl, true);
                const formData = new FormData();
                formData.append("action", "portfolio_simulation");
                formData.append("amount", amount);
                formData.append("portfolio_type", portfolioType);
                formData.append("nonce", nonce);

                const response = await fetch(ajaxUrl, {
                    method: "POST",
                    body: formData
                });

                const result = await response.json();

                if (!response.ok || !result.success) {
                    throw new Error(result?.data?.message || "Simulation failed");
                }

                const principalEl = simulatorEl.closest(".simulator")?.querySelector(".simulator-principal");
                const returnEl = simulatorEl.closest(".simulator")?.querySelector(".simulator-return");

                if (principalEl && result.data?.profitability) {
                    principalEl.textContent = result.data.profitability;
                }

                if (returnEl && typeof result.data?.return !== "undefined") {
                    returnEl.textContent = result.data.return;
                }

                simulatorEl.dataset.simulated = "true";
            } catch (error) {
                console.error("Simulation request error:", error);
            } finally {
                setSimulatorLoading(simulatorEl, false);
            }
        }

        document.addEventListener("input", function (event) {
            const input = event.target.closest(".simulator-amount");
            if (!input) return;

            let value = input.value.replace(/[^0-9.]/g, "");

            const hasDot = value.includes(".");
            const firstDotIndex = value.indexOf(".");

            if (firstDotIndex !== -1) {
                value =
                    value.slice(0, firstDotIndex + 1) +
                    value.slice(firstDotIndex + 1).replace(/\./g, "");
            }

            let [integerPart, decimalPart = ""] = value.split(".");

            decimalPart = decimalPart.slice(0, 2);
            if (!/^0\d+/.test(integerPart)) {
                integerPart = integerPart.replace(/^0+(?=\d)/, "");
            }
            integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            if (!integerPart && hasDot) {
                integerPart = "0";
            }

            input.value = hasDot
                ? `${integerPart}.${decimalPart}`
                : integerPart;

            const simulatorEl = input.closest(".simulator-instance");
            updateSimulatorLink(simulatorEl);
        });

        document.addEventListener("blur", function (event) {
            const input = event.target.closest(".simulator-amount");
            if (!input) return;

            const min = Number(input.dataset.min || 5000);
            const rawValue = (input.value || "").replace(/,/g, "");
            const amount = Number(rawValue);

            if (!rawValue || Number.isNaN(amount)) return;

            if (amount < min) {
                input.value = min.toLocaleString("en-US", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                });
            }

            const simulatorEl = input.closest(".simulator-instance");
            updateSimulatorLink(simulatorEl);
        }, true);

        document.addEventListener("click", function (event) {
            const detailsLink = event.target.closest(".simulator-external-link");
            if (detailsLink) {
                event.preventDefault();

                let onboardingUrl = detailsLink.dataset.onboardingUrl?.trim();

                if (!onboardingUrl) {
                    const simulatorEl = detailsLink.closest(".simulator")?.querySelector(".simulator-instance");
                    const portfolioId = simulatorEl?.dataset.portfolioId?.trim();
                    const amount = simulatorEl?.querySelector(".simulator-amount")?.value?.trim();

                    if (portfolioId && amount) {
                        onboardingUrl = buildOnboardingUrl(portfolioId, amount);
                        detailsLink.dataset.onboardingUrl = onboardingUrl;
                    }
                }

                openSimulatorDetailsModal(onboardingUrl);
                return;
            }

            const button = event.target.closest(".simulator-trigger");
            if (!button) return;

            const simulatorEl = button.closest(".simulator-instance");
            syncSimulatorAmounts(simulatorEl);
            runSimulation(simulatorEl);
        });

        const tabButtons = document.querySelectorAll('[data-bs-toggle="tab"]');

        tabButtons.forEach((tabButton) => {
            tabButton.addEventListener("shown.bs.tab", function (event) {
                const targetSelector = event.target.getAttribute("data-bs-target");
                if (!targetSelector) return;

                const tabPane = document.querySelector(targetSelector);
                if (!tabPane) return;

                const simulatorEl = tabPane.querySelector(".simulator-instance");
                if (!simulatorEl) return;

                if (simulatorEl.dataset.simulated === "true") return;

                runSimulation(simulatorEl);
            });
        });

        window.addEventListener("load", function () {
            const initiallyActivePane = document.querySelector(".tab-pane.show.active");
            if (initiallyActivePane) {
                const simulatorEl = initiallyActivePane.querySelector(".simulator-instance");
                if (simulatorEl && simulatorEl.dataset.simulated !== "true") {
                    runSimulation(simulatorEl);
                }
            }
        });

        function buildOnboardingUrl(portfolioId, amount) {
            const cleanAmount = String(amount || "").replace(/,/g, "").trim();

            if (!simulatorIframeBaseUrl) {
                return "#";
            }

            const params = new URLSearchParams({
                portfolioId: portfolioId,
                amount: cleanAmount,
                isPublicWeb: "true"
            });

            return `${simulatorIframeBaseUrl}/#/public/portfolio-detail?${params.toString()}`;
        }

        function setSimulatorLoading(simulatorEl, isLoading) {
            const locale = window.siteLocale;
            const loadingText = locale === "en_US" ? "Loading..." : "Cargando...";
            const amountInput = simulatorEl.querySelector(".simulator-amount");
            const button = simulatorEl.querySelector(".simulator-trigger");

            if (amountInput) amountInput.disabled = isLoading;

            if (button) {
                button.disabled = isLoading;

                button.dataset.originalText = button.dataset.originalText || button.textContent;

                button.innerHTML = isLoading
                    ? `<span class="d-inline-flex align-items-center justify-content-center gap-2">
                     <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                     <span>${loadingText}</span>
                   </span>`
                    : button.dataset.originalText;
            }
        }

        function updateSimulatorLink(simulatorEl) {
            if (!simulatorEl) return;

            const simulatorWrapper = simulatorEl.closest(".simulator");
            if (!simulatorWrapper) return;

            const link = simulatorWrapper.querySelector(".simulator-external-link");
            if (!link) return;

            const portfolioId = simulatorEl.dataset.portfolioId?.trim();
            const amountInput = simulatorEl.querySelector(".simulator-amount");
            const amount = amountInput?.value?.trim();

            if (!portfolioId || !amount) {
                link.setAttribute("href", "#");
                link.removeAttribute("data-onboarding-url");
                return;
            }

            link.setAttribute("href", "#");
            link.setAttribute("data-onboarding-url", buildOnboardingUrl(portfolioId, amount));
        }

        window.runSimulation = runSimulation;
        document.querySelectorAll(".simulator-amount").forEach(input => {
            input.dispatchEvent(new Event("input", { bubbles: true }));
            const simulatorEl = input.closest(".simulator-instance");
            updateSimulatorLink(simulatorEl);
        });
    }
}
